module.exports = __webpack_public_path__ + "img/lea-29.2d11bbeb.png";